/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * /license/feature接口返回的特性列表的key，比如: [{"HyperMetro-Inner": 1}]。
 * 该值配置在ibase_cfg.xml文件中。
 */
export enum LicenseKey {
    /**
     * 快照
     */
    HyperSnap = 'HyperSnap',
    /**
     * 克隆
     */
    HyperClone = 'HyperClone',
    /**
     * 智能数据迁移
     */
    SmartMigration = 'SmartMigration',
    /**
     * 文件系统智能迁移
     */
    SmartMove = 'SmartMove',
    /**
     * 智能服务质量控制
     */
    SmartQoS = 'SmartQoS',
    /**
     * 智能缓存服务
     */
    SmartCache = 'SmartCache',
    /**
     * 远程复制
     */
    HyperReplication = 'HyperReplication',
    /**
     * 智能精简配置
     */
    SmartThin = 'SmartThin',
    /**
     * thick lun
     */
    SmartThick = 'Thick LUN',
    /**
     * XVE系统软件
     */
    XVE_System = 'XVE System',
    /**
     * 管理软件
     */
    Management_Console = 'ManagementConsole',
    /**
     * 异构虚拟化
     */
    SmartVirtualization = 'SmartVirtualization',
    /**
     * SAN双活
     */
    HyperMetro = 'HyperMetro',
    /**
     * 智能数据重删-LUN专用(SmartDedupe) 67
     */
    SmartDedupe = 'SmartDedupe （for LUN）',
    /**
     * 智能数据压缩-LUN专用(SmartCompression) 68
     */
    SmartCompression = 'SmartCompression（for LUN）',
    /**
     * 云复制
     */
    CloudReplication = 'CloudReplication',
    /**
     * 专属云认证
     */
    DessAuthentication = 'DessAuthentication',
    /**
     * HyperCDP
     */
    HyperCDP = 'HyperCDP',
    /**
     * CloudBackup
     */
    CloudBackup = 'CloudBackup',
    /**
     * 承诺容量
     */
    GuaranteedCapacity = 'Effective Capacity',
    /**
     * Special License
     */
    SpecialLicense = 'Special License',
    /**
     * 重删压缩软件基础版
     */
    DedupeAndCompressionBasic = 'SmartDedupe & SmartCompression Software License Basic',
    /**
     * 重删压缩软件标准版
     */
    DedupeAndCompressionStandard = 'SmartDedupe & SmartCompression Software License Standard',
    /**
     * 重删压缩软件增强版
     */
    DedupeAndCompressionEnhanced = 'SmartDedupe & SmartCompression Software License Enhanced',
    /**
     * 重删压缩软件高级版
     */
    DedupeAndCompressionAdvanced = 'SmartDedupe & SmartCompression Software License Advanced',
    /**
     * 重删压缩软件超级版
     */
    DedupeAndCompressionPremium = 'SmartDedupe & SmartCompression Software License Premium',
    /**
     * 重删压缩软件超级版预留1
     */
    DedupeAndCompressionPremiumReserved1 = 'SmartDedupe & SmartCompression Software License Premium Reserved 1',
    /**
     * 重删压缩软件超级版预留2
     */
    DedupeAndCompressionPremiumReserved2 = 'SmartDedupe & SmartCompression Software License Premium Reserved 2',
    /**
     * 重删压缩软件超级版预留3
     */
    DedupeAndCompressionPremiumReserved3 = 'SmartDedupe & SmartCompression Software License Premium Reserved 3',
    /**
     * 智能数据压缩 ID:114
     */
    Smart_Compression = 'SmartCompression',
    /**
     * 重删压缩软件超级版预留4
     */
    DedupeAndCompressionPremiumReserved4 = 'SmartDedupe & SmartCompression Software License Premium Reserved 4',
    /**
     * 重删压缩软件专享版
     */
    DedupeAndCompressionExclusive = 'SmartDedupe & SmartCompression Software License Exclusive',
    /**
     * 智能重删压缩许可基础版
     */
    SmartDedupeAndCompressionBasic = 'SmartDedupe & SmartCompression License Basic Edition',
    /**
     * NAS基础特性
     */
    NAS = 'NAS Foundation',
    /**
     * 内置容器许可（已改为FTP, HTTP License）
     */
    SmartContainerLicense = 'FTP,HTTP License',
    /**
     * 内置容器许可标准版
     */
    SmartContainerLicenseStandard = 'SmartContainer License(Standard)',
    /**
     * 内置容器许可超级版
     */
    SmartContainerLicensePremium = 'SmartContainer License(Premium)',
    /**
     * 内双活特性
     */
    InnerHyperMetro = 'HyperMetro-Inner',
    /**
     * NAS双活特性
     */
    FileHyperMetro = 'HyperMetroNAS',
    /**
     * 多租户
     */
    SmartMultiTenant = 'SmartMulti_Tenant',
    /**
     * worm
     */
    HyperLock = 'HyperLock',
    /**
     * 重删压缩软件基础版（融合存储）
     */
    DedupeAndCompressionBasicConvergedStorage = 'SmartDedupe & SmartCompression Software License Basic(Converged storage)',
    /**
     * 重删压缩软件专享版（融合存储）
     */
    DedupeAndCompressionExclusiveConvergedStorage = 'SmartDedupe & SmartCompression Software License Exclusive(Converged storage)',
    /**
     * 智能数据加速（SmartAcceleration）
     */
    SmartAcceleration = 'SmartAcceleration',
    /**
     * 数据缩减软件（微存储）
     */
    DataReductionSoftwareRaid = 'Data Reduction Software(Including RAID)',
    /**
     * 勒索软件检测
     */
    AntiRansomware = 'HyperDetect (anti-Ransomware)',
    /**
     * 勒索软件检测 for SAN
     */
    ANTIRANSOMWARE_FOR_SAN = 'HyperDetect for SAN',
    /**
     * BDM数据加密特性（存储池软加密）
     */
    HyperEncryption = 'HyperEncryption',
    /**
     * 国内软加密特性（支持SM4加密算法）
     */
    HYPER_ENCRYPTION_SM4 = 'HyperEncryption_SM4',
    /**
     * 源端重删
     */
    SourceDedupe = 'SourceDedupe',
    /**
     * x8000系列容器备份
     */
    DataBackUpCapacity = 'Data Backup Capacity',
    /**
     * 文件升级为文件和对象多协议融合存储（S3 license）
     */
    S3 = 'Upgrade from File Storage to File and Object Converged Storage',
    /**
     * 数据缩减软件，计算型存储2910的重删压缩license（只支持重删，不支持压缩）
     */
    DataReductionSoftware = 'Data Reduction Software',
    /**
     * 跨NAS存储分级（文件分级）
     */
    SmartMobilityNAS = 'SmartMobility-NAS',
    /**
     * 分级上云（文件分级上云）
     */
    SmartMobilityObject = 'SmartMobility-Object',
    /**
     * 文件系统迁移
     */
    SmartMigrationForNAS = 'SYS_LICENSE_SMART_MIGRATION_FOR_NAS',
    /**
     * HyperLink(SOCC)
     */
    HyperLinkSOCC = 'SYS_LICENSE_HYPER_LINK',
    /**
     * DBStor客户端
     */
    DBStorClient = 'DBStor Client',
    /**
     * 虚拟机（目前仅支持微存储）
     */
    VirtualEnvironmentEnabler = 'Virtual Environment Enabler',
    /**
     * 容量控制许可（不含重删压缩）
     */
    CAPACITY_CONTROL_LICENSE = 'Capacity Control License(without SmartDedupe & SmartCompression)',
}
